var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "message waba-template-message",
      class: ((_obj = {}), (_obj[_vm.float] = true), _obj),
    },
    [
      _c("div", { staticClass: "content" }, [
        _vm.getMetaText()
          ? _c("div", { staticClass: "meta-header" }, [
              _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
              _vm._v(
                "\n            " + _vm._s(_vm.getMetaText()) + "\n        "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.meta.headerText
          ? _c("div", { staticClass: "header-text" }, [
              _vm._v(_vm._s(_vm.meta.headerText)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "body" }, [_vm._v(_vm._s(_vm.meta.body))]),
        _vm._v(" "),
        _vm.meta.buttons.length > 0
          ? _c(
              "div",
              { staticClass: "buttons" },
              _vm._l(_vm.meta.buttons, function (button, i) {
                return _c(
                  "div",
                  {
                    key: button.id,
                    staticClass: "single-button",
                    class: { selected: false },
                    on: { click: function ($event) {} },
                  },
                  [
                    _c("div", {
                      staticClass: "single-button-text",
                      domProps: { innerHTML: _vm._s(button.text) },
                    }),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.meta.footer
          ? _c("div", { staticClass: "footer" }, [
              _vm._v(_vm._s(_vm.meta.footer)),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "carousel-messages-container" }, [
        _vm.meta.templateType === "CAROUSEL"
          ? _c(
              "div",
              { staticClass: "carousel-messages" },
              _vm._l(_vm.meta.cards, function (card) {
                return _c(
                  "div",
                  { staticClass: "carousel-messages-item" },
                  [
                    !card.mediaUrl
                      ? [
                          _c("img", {
                            attrs: {
                              width: "100%",
                              src: _vm.getDefaultImage(card.headerType),
                              alt: "''",
                            },
                          }),
                        ]
                      : [
                          card.headerType === "VIDEO"
                            ? _c("div", [
                                _c("video", {
                                  attrs: {
                                    width: "100%",
                                    src: card.mediaUrl,
                                    controls: "",
                                  },
                                }),
                              ])
                            : card.headerType === "IMAGE"
                            ? _c("div", [
                                _c("img", {
                                  attrs: {
                                    width: "100%",
                                    src: card.mediaUrl,
                                    alt: "",
                                  },
                                }),
                              ])
                            : card.headerType === "DOCUMENT"
                            ? _c("div", [
                                _c("img", {
                                  attrs: {
                                    src: _vm.getDefaultImage(),
                                    alt: "''",
                                  },
                                }),
                              ])
                            : _vm._e(),
                        ],
                    _vm._v(" "),
                    _c("div", { staticClass: "body" }, [
                      _vm._v(_vm._s(_vm.getCardBody(card.body))),
                    ]),
                  ],
                  2
                )
              }),
              0
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }